import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Content } from '@amfam/shared/utility/shared-services/lib/content/content.model';
import { ContentService } from '@amfam/shared/utility/shared-services/lib/content/content.service';

@Injectable({ providedIn: 'root' })
export class ClaimFaqService {
  private contentService = inject(ContentService);

  public getClaimsFaq(): Observable<Content> {
    return this.contentService.getContent('faq', 'claims');
  }
}
